import ability from '@/common/ability';

export interface OperationActions<T = ComputeTaskObject> {
  [key: string]: {
    fn: (obj: T) => void,
    ability?: string
  };
}

type ComputeNotificationsHandlerParams<T> = {
  eventType: string;
  resource: string;
  operationActions: OperationActions<T>;
};

type ComputeNotificationsHandler = <T = ComputeTaskObject>(params: ComputeNotificationsHandlerParams<T>) => (event: SocketEvent<T>) => Promise<void>;

export const computeNotificationsHandler: ComputeNotificationsHandler = ({ eventType, resource, operationActions }) => async (event) => {
  if (!event) {
    return Promise.resolve();
  }

  const { type, operation, object } = event;

  if (type === eventType) {
    const action = operationActions[operation];

    if (!action) {
      return Promise.resolve();
    }

    const actionToCheck = action.ability || 'read';

    if (!action.ability || (action.ability && ability.can(actionToCheck, resource))) {
      return action.fn(object);
    }
  }

  return Promise.resolve();
};
